<template>
    <div>
        <ul>
            <li
                v-for="option in options"
                :key="option.id"
            >
                <CategoryFilterOption
                    :active="filterBy === option.id"
                    @click="filter(option.id)"
                >
                    {{ option.name }}
                </CategoryFilterOption>
            </li>
        </ul>
    </div>
</template>

<script>
import CategoryFilterOption from '@/components/CategoryFilterOption.vue';

export default {
    components: { CategoryFilterOption },

    props: {
        filterBy: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            options: [
                {
                    id: 'all',
                    name: 'All',
                },
                {
                    id: 'personalised',
                    name: 'Personalised',
                },
                {
                    id: 'non-personalised',
                    name: 'Non-personalised',
                },
            ],
        };
    },

    methods: {
        filter(filterString) {
            this.$emit('change:filter-by', filterString);
        },
    },

};
</script>

<style lang="scss" scoped>
</style>
